export enum FieldType {
  DATE = 'DATE',
  DATE_TIME = 'DATE_TIME',
  DECIMAL = 'DECIMAL',
  NUMBER = 'NUMBER',
  STRING = 'STRING'
}
